<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big">THE</span></p>
<p class="center"><img alt="" src="OEBPS/images/tp_everuthing.jpg"/></p>
<p class="center" style="line-height: 2em;"><strong><span class="big2">PARENT’S GUIDE TO</span><br/><span class="big3">EATING<br/>DISORDERS</span></strong><br/></p>
<p class="center"><span class="big4">The information you need to see the warning signs, help promote positive body image, and develop a recovery plan for your child</span><br/><br/></p>
<p class="center"><span class="big4">Angie Best-Boss, MA</span><br/>Content Editor, <a class="hlink" href="http://EatingDisordersOnline.com" target="_blank">EatingDisordersOnline.com</a><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?25cb8bfd